import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';

export function getAmateurFilmTags(params) {
    let axios = getAxios();

    return axios.request({
        url: '/amateur_films/tags/',
        method: 'get',
        params
    });
}

export function getAmateurFilms(params) {
    let axios = getAxios();

    return axios.request({
        url: '/amateur_films/',
        method: 'get',
        params: addAuthTokenData(params)
    });
}

export function getAmateurFilmsTagged({slug, ...params}) {
    let axios = getAxios();

    return axios.request({
        url: '/amateur_films/tagged/',
        method: 'get',
        params: {slug, ...params}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/amateurFilms.js